import { render } from "./CreateFolder.vue?vue&type=template&id=3ee5e4e6"
import script from "./CreateFolder.vue?vue&type=script&lang=js"
export * from "./CreateFolder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Thanusan/My/TRAINN-Assignment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__